import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {BaseValue} from '@mintdata/mint-kit/api/values/BaseValue';
import {serializable} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

export class AEmpty extends BaseValue
{
    public static readonly Value = new AEmpty();

    @serializable public readonly __isEmpty:boolean = true;

    private constructor()
    {
        super(Type.Empty);
    }

    public toString():string
    {
        return '';
    }

    public toValue():string
    {
        return null;
    }

    public isEqualTo(other:IValue):boolean
    {
        return other &&
            other === this as IValue;
    }

    public compareTo(other:IValue):number
    {
        if( this.isEqualTo(other) )
            return 0;

        return -1;
    }

    public clone():IValue
    {
        return new AEmpty();
    }

    public static isSerializedEmptyValue(obj:any):boolean
    {
        return obj &&
            obj.__type &&
            obj.__type.toLowerCase() === Type.Empty.kind.toLowerCase();
    }

    public static circularRefResolver(value:string):IValue
    {
        // KEEP_ALIVE! Fix for resolving import circular dependencies for AError and ABaseValue
        return new AError('ERROR: Deprecated');
    }

    public static array(n:number):Array<AEmpty>
    {
        return Array(n).fill(AEmpty.Value);
    }

}
